// extracted by mini-css-extract-plugin
export default {"content":"styles_content__OK3oN","title":"styles_title__lPTlz"};